<template>
    <div>
        <CRow>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>جزییات پیام</strong>
                    </CCardHeader>
                    <CCardBody>
                        <div v-if="$route.params.type == 'groups'">
                            <CDataTable hover striped :items="items" :fields="fields_groups" columnFilter 
                                :items-per-page="15" :active-page="active_page" :pagination="{ doubleArrows: true, align: 'center'}"
                                :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }" >
                                <template #state="data">
                                    <td>
                                        <CBadge :color="get_badge(data.item.state)">
                                            {{data.item.state}}
                                        </CBadge>
                                    </td>
                                </template>
                            </CDataTable>
                        </div>
                        <div v-else>
                            <CDataTable hover striped :items="items" :fields="fields" 
                                :items-per-page="15" :active-page="active_page" :pagination="{ doubleArrows: true, align: 'center'}"
                                :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }" />
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>
<script>
export default {
    data () {
        return {
            items: [],
            fields_groups: [
                { key: 'to_num', label: 'به شماره' },
                { key: 'message_uuid', label: 'UUID' },
                { key: 'operator_id', label: 'اپراتور' },
                { key: 'other_side_id', label: 'other side ID' },
                { key: 'sms_fee', label: 'هزینه پیام' },
                { key: 'state', label: 'وضعیت' },
            ],
            active_page: 1,
        }
    },
    computed: {
        fields(){
            return [
                { key: 'key', label: '', _style: 'width:150px'},
                { key: 'value', label: '', _style: 'width:150px;' }
            ]
        }
    },
    mounted(){
        this.get();
    },
    methods: {
        get() {
            switch(this.$route.params.type){
                case 'send':
                    this.axios.get('sms_messages/'
                        + '?out_box_sms_messages.message_uuid=' + this.$route.params.uuid)
                        .then(res => {
                            res.data.map(val => {
                                this.items.push(
                                    {key: 'کاربر', value: val['users.user_full_name']},
                                    {key: 'از شماره', value: val['out_box_sms_groups.from_number']},
                                    {key: 'به شماره', value: val['out_box_sms_messages.to_num']},
                                    {key: 'پیام', value: val['out_box_sms_groups.sms_text']},
                                    {key: 'هزینه پیام', value: val['out_box_sms_messages.sms_fee']},
                                );
                                this.axios.get('/mobile_operators/?id=' 
                                    + val['out_box_sms_messages.operator_id'])
                                    .then(res => {
                                        this.items.push({key: 'نام اپراتور', value: res.data[0].name});
                                    })
                                    .catch(() => {
                                        this.items.push({key: 'نام اپراتور', value: '---'});
                                    })
                                this.items.push(
                                    {key: 'تاریخ ایجاد', value: this.$moment(val['out_box_sms_messages.created_at'], 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD')},
                                );
                                if(val['out_box_sms_groups.send_at'] == '0001-01-01T00:00:00Z'){
                                    this.items.push(
                                        {key: 'تاریخ ارسال', value: '---'},
                                    );
                                } else{
                                    this.items.push(
                                        {key: 'تاریخ ارسال', value: this.$moment(val['out_box_sms_groups.send_at'], 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD')},
                                    );
                                }
                                if(val['out_box_sms_messages.next_sms_delivery_check'] == '0001-01-01T00:00:00Z'){
                                    this.items.push(
                                        {key: 'next SMS delivery check', value: '---'},
                                    );
                                } else{
                                    this.items.push(
                                        {key: 'next SMS delivery check', value: this.$moment(val['out_box_sms_messages.next_sms_delivery_check'], 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD')},
                                    );
                                }
                                this.items.push(
                                    {key: 'UUID', value: val['out_box_sms_messages.message_uuid']},
                                );
                                if(this.$store.state.perms.can_view_other_side_id){
                                    this.items.push(
                                        {key: 'other side ID', value: val['out_box_sms_messages.other_side_id']},
                                    );
                                }
                                if(val['is_sound_message'] == true){
                                    this.items.push(
                                        {key: 'نوع پیام', value: val['sound_message_info']['message_type']},
                                    );
                                    if(val['sound_message_info']['message_type'] == 'OTP'){
                                        this.items.push(
                                            {key: 'OTP', value: val['sound_message_info']['otp_string']},
                                        );
                                    } else {
                                        this.items.push(
                                            {key: 'TTS', value: val['sound_message_info']['tts_string']},
                                        );
                                    }
                                    this.items.push(
                                        {key: 'مدت زمان فایل', value: val['sound_message_info']['sound_file_len']},
                                        {key: 'هزینه هر ثانیه', value: val['sound_message_info']['sound_file_per_second_price']},
                                        {key: 'ثانیه‌های پخش شده', value: val['sound_message_info']['final_bill_seconds']},
                                    );
                                } else {
                                    this.axios.get('/sms_groups/?group_uuid=' 
                                        + val['out_box_sms_groups.group_uuid'])
                                        .then(res => {
                                            this.items.push(
                                                {key: 'تعداد صفحه', value: res.data[0].page_count}
                                            );
                                            if(res.data[0].is_persian){
                                                this.items.push(
                                                    {key: 'کاراکتر فارسی', value: 'بله'},
                                                );
                                            } else{
                                                this.items.push(
                                                    {key: 'کاراکتر فارسی', value: 'خیر'},
                                                );
                                            }
                                        })
                                        .catch(() => {
                                            this.items.push(
                                                {key: 'تعداد صفحه', value: '---'},
                                                {key: 'کاراکتر فارسی', value: '---'},
                                            );
                                        })
                                }
                                switch(val['out_box_sms_messages.state']){
                                    case -1:
                                        val['out_box_sms_messages.state'] = 'لیست سیاه';
                                        break;
                                    case -2:
                                        val['out_box_sms_messages.state'] = 'تایید نشده';
                                        break;
                                    case -3:
                                        val['out_box_sms_messages.state'] = 'خطا در ارسال';
                                        break;
                                    case 0:
                                        if(val['out_box_sms_messages.is_send'] == false){
                                            val['out_box_sms_messages.state'] = 'ارسال نشده';
                                        } else {
                                            val['out_box_sms_messages.state'] = 'ارسال شده و در انتظار تعیین وضعیت';
                                        } 
                                        break;
                                    case 1:
                                        val['out_box_sms_messages.state'] = 'تحویل داده شده';
                                        break;
                                    case 2:
                                        val['out_box_sms_messages.state'] = 'تحویل داده نشده';
                                        break;
                                    case 3:
                                        val['out_box_sms_messages.state'] = 'ارسال شده به مخابرات';
                                        break;
                                }
                                this.items.push(
                                    {key: 'وضعیت', value: val['out_box_sms_messages.state']},
                                );
                            });
                        })
                    break;
                case 'archive':
                    this.axios.get('sms_message_archive/'
                        + '?out_box_sms_message_backups.message_uuid=' + this.$route.params.uuid)
                        .then(res => {
                            res.data.map(val => {
                                this.items.push(
                                    {key: 'کاربر', value: val['users.user_full_name']},
                                    {key: 'از شماره', value: val['out_box_sms_group_backups.from_number']},
                                    {key: 'به شماره', value: val['out_box_sms_message_backups.to_num']},
                                    {key: 'پیام', value: val['out_box_sms_group_backups.sms_text']},
                                    {key: 'هزینه پیام', value: val['out_box_sms_message_backups.sms_fee']},
                                );
                                this.axios.get('/mobile_operators/?id=' 
                                    + val['out_box_sms_message_backups.operator_id'])
                                    .then(res => {
                                        this.items.push({key: 'نام اپراتور', value: res.data[0].name});
                                    })
                                    .catch(() => {
                                        this.items.push({key: 'نام اپراتور', value: '---'});
                                    })
                                this.items.push(
                                    {key: 'تاریخ ایجاد', value: this.$moment(val['out_box_sms_message_backups.created_at'], 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD')},
                                );
                                if(val['out_box_sms_group_backups.send_at'] == '0001-01-01T00:00:00Z'){
                                    this.items.push(
                                        {key: 'تاریخ ارسال', value: '---'},
                                    );
                                } else{
                                    this.items.push(
                                        {key: 'تاریخ ارسال', value: this.$moment(val['out_box_sms_group_backups.send_at'], 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD')},
                                    );
                                }
                                if(val['out_box_sms_message_backups.next_sms_delivery_check'] == '0001-01-01T00:00:00Z'){
                                    this.items.push(
                                        {key: 'next SMS delivery check', value: '---'},
                                    );
                                } else{
                                    this.items.push(
                                        {key: 'next SMS delivery check', value: this.$moment(val['out_box_sms_message_backups.next_sms_delivery_check'], 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD')},
                                    );
                                }
                                this.items.push(
                                    {key: 'UUID', value: val['out_box_sms_message_backups.message_uuid']},
                                );
                                if(this.$store.state.perms.can_view_other_side_id){
                                    this.items.push(
                                        {key: 'other side ID', value: val['out_box_sms_message_backups.other_side_id']},
                                    );
                                }
                                if(val['is_sound_message'] == true){
                                    this.items.push(
                                        {key: 'نوع پیام', value: val['sound_message_info']['message_type']},
                                    );
                                    if(val['sound_message_info']['message_type'] == 'OTP'){
                                        this.items.push(
                                            {key: 'OTP', value: val['sound_message_info']['otp_string']},
                                        );
                                    } else {
                                        this.items.push(
                                            {key: 'TTS', value: val['sound_message_info']['tts_string']},
                                        );
                                    }
                                    this.items.push(
                                        {key: 'مدت زمان فایل', value: val['sound_message_info']['sound_file_len']},
                                        {key: 'هزینه هر ثانیه', value: val['sound_message_info']['sound_file_per_second_price']},
                                        {key: 'ثانیه‌های پخش شده', value: val['sound_message_info']['final_bill_seconds']},
                                    );
                                } else {
                                    this.axios.get('/sms_groups/?group_uuid=' 
                                        + val['out_box_sms_group_backups.group_uuid'])
                                        .then(res => {
                                            this.items.push(
                                                {key: 'تعداد صفحه', value: res.data[0].page_count}
                                            );
                                            if(res.data[0].is_persian){
                                                this.items.push(
                                                    {key: 'کاراکتر فارسی', value: 'بله'},
                                                );
                                            } else{
                                                this.items.push(
                                                    {key: 'کاراکتر فارسی', value: 'خیر'},
                                                );
                                            }
                                        })
                                        .catch(() => {
                                            this.items.push(
                                                {key: 'تعداد صفحه', value: '---'},
                                                {key: 'کاراکتر فارسی', value: '---'},
                                            );
                                        })
                                }
                                switch(val['out_box_sms_message_backups.state']){
                                    case -1:
                                        val['out_box_sms_message_backups.state'] = 'لیست سیاه';
                                        break;
                                    case -2:
                                        val['out_box_sms_message_backups.state'] = 'تایید نشده';
                                        break;
                                    case -3:
                                        val['out_box_sms_message_backups.state'] = 'خطا در ارسال';
                                        break;
                                    case 1:
                                        val['out_box_sms_message_backups.state'] = 'تحویل داده شده';
                                        break;
                                    case 2:
                                        val['out_box_sms_message_backups.state'] = 'تحویل داده نشده';
                                        break;
                                    case 3:
                                        val['out_box_sms_message_backups.state'] = 'ارسال شده به مخابرات';
                                        break;
                                }
                                this.items.push(
                                    {key: 'وضعیت', value: val['out_box_sms_message_backups.state']},
                                );
                            });
                        })
                    break;
                case 'inbox':
                    this.axios.get('inbox_sms_messages/'
                        + '?id=' + this.$route.params.uuid
                        + '&user_info=1')
                        .then(res => {
                            res.data.map(val => {
                                this.items.push(
                                    {key: 'شناسه', value: val.id},
                                    {key: 'کاربر', value: `${val.user_info.first_name} ${val.user_info.last_name}`},
                                    {key: 'از شماره', value: val.from_number},
                                    {key: 'به شماره', value: val.to_number},
                                    {key: 'تاریخ ایجاد', value: this.$moment(val.created_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD')},
                                    {key: 'پیام', value: val.sms_text}
                                );
                                if(val.send_info.length != 0){
                                    this.items.push(
                                        {key: 'URL', value: val.send_info.url},
                                        {key: 'تاریخ ارسال', value: this.$moment(val.send_info.send_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD')},
                                        {key: 'وضعیت بازگشت', value: val.send_info.return_state},
                                    );
                                }
                            })
                        })
                    break;
                case 'groups':
                    this.axios.get('sms_groups_archive/'
                        + '?group_uuid=' + this.$route.params.uuid
                        + '&out_box_sms_messages=1')
                        .then(res => {
                            res.data[0].items = [];
                            let item = {};
                            for(const key in res.data[0].out_box_sms_messages){
                                item = {};
                                for(const k in res.data[0].out_box_sms_messages[key]){
                                    if(k == 'state'){
                                         switch(res.data[0].out_box_sms_messages[key][k]){
                                            case 1:
                                                item[k] = 'تحویل داده شده';
                                                break;
                                            case 2:
                                                item[k] = 'تحویل داده نشده';
                                                break;
                                            case 3:
                                                item[k] = 'ارسال شده به مخابرات';
                                                break;
                                            case 0:
                                                item[k] = 'در صف ارسال | ارسال شده و در انتظار تعیین وضعیت';
                                                break;
                                            case -1:
                                                item[k] = 'لیست سیاه';
                                                break;
                                            case -2:
                                                item[k] = 'تایید نشده';
                                                break;
                                            case -3:
                                                item[k] = 'خطا در ارسال';
                                                break;
                                        }
                                    }
                                    else{
                                        item[k] = res.data[0].out_box_sms_messages[key][k];
                                    }
                                }
                                res.data[0].items.push(item);
                            }
                            this.items = res.data[0].items;
                        })
            }
        },
        get_badge(status) {
            switch(status) {
                case 'لیست سیاه': return 'danger';
                case 'رد شده': return 'danger';
                case 'در صف ارسال | ارسال شده و در انتظار تعیین وضعیت': return 'info';
                case 'تحویل داده نشده': return 'danger';
                case 'تحویل داده شده': return 'success';
                case 'تایید نشده': return 'warning';
                case 'خطا در ارسال': return 'danger';
                case 'ارسال شده به مخابرات': return 'info';
            }
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.can_view_sms_message_page == false
            && this.$store.state.perms.can_view_inbox_sms_message_page == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
